import { Document, Page, pdfjs } from "react-pdf";
import { MainTitle, MaxWidth } from "../../../styles/theme";
import { useCallback, useMemo, useState } from "react";

// CDN에서 worker 로드
pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.js`;

type GuidePdfViewerProps = {
  filePath: string;
};

const GuidePdfViewer = ({ filePath }: GuidePdfViewerProps) => {
  const [numPages, setNumPages] = useState<number>();

  const onDocumentLoadSuccess = useCallback(
    ({ numPages }: { numPages: number }): void => {
      setNumPages(numPages);
    },
    []
  );

  const pageStyle = useMemo(
    () => ({
      marginBottom: "20px",
      textAlign: "center" as const,
      display: "block",
      pageBreakAfter: "avoid" as const,
    }),
    []
  );

  const optimizedRenderAllPages = useMemo(() => {
    if (!numPages) return null;

    const pages = [];
    for (let i = 1; i <= numPages; i++) {
      pages.push(
        <div key={i} style={pageStyle}>
          <Page
            pageNumber={i}
            renderTextLayer={false}
            renderAnnotationLayer={false}
          />
        </div>
      );
    }
    return pages;
  }, [numPages, pageStyle]);

  return (
    <MaxWidth>
      <Document
        file={filePath}
        onLoadSuccess={onDocumentLoadSuccess}
        loading="PDF 로딩 중..."
      >
        {optimizedRenderAllPages}
      </Document>
    </MaxWidth>
  );
};

export default GuidePdfViewer;
